import React from "react"; // add this

export default function AccessRequired() {
  const requestAccess = async () => {
    await fetch("/auth/login", {
      method: "POST",
      credentials: "include",
    });
    alert("Access request submitted");
  };

  return (
    <div style={styles.container}>
      <h2>IDE Access Required</h2>
      <p>
        To use the online IDE, you need instructor approval or an active
        subscription.
      </p>

      <button onClick={requestAccess} style={styles.button}>
        Request Instructor Approval
      </button>

      <button
        onClick={() => (window.location.href = "/subscribe")}
        style={{ ...styles.button, marginTop: "10px" }}
      >
        Subscribe Now
      </button>
    </div>
  );
}

const styles = {
  container: {
    padding: "40px",
    maxWidth: "500px",
  },
  button: {
    padding: "12px 18px",
    width: "100%",
  },
};
